import { IconButton } from "@similarweb/ui-components";
import {
    StyledIntentSelectedTopicItemContainer,
    StyledTopicBlock,
    StyledTopicDomainCount,
    StyledTopicName,
    StyledTopicNameText,
    StyledTopicRemoveBtnCrossWrapper,
    StyledTopicRemoveBtnWrapper,
} from "app/pages/sales-intelligence/pages/manage-signals/components/IntentSelectedTopicItem/styles";
import type { FC } from "react";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import { useSelector } from "react-redux";
import { selectIsLocked } from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import { formatNumberWithComa } from "app/pages/sales-intelligence/utils/leads";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { translate } from "app/filters/i18nFilter";

type IntentSelectedTopicItemProps = {
    topic: Topic;
    onRemoveTopic: (topic: Topic) => void;
    isExtraTopicItem: boolean;
};

const IntentSelectedTopicItem: FC<IntentSelectedTopicItemProps> = ({ topic, onRemoveTopic, isExtraTopicItem }) => {
    const { name, domainsCount, isNotApplied } = topic;
    const isLocked = useSelector(selectIsLocked);

    return (
        <StyledIntentSelectedTopicItemContainer>
            <StyledTopicBlock>
                <StyledTopicName isExtraItem={isExtraTopicItem}>
                    <StyledTopicNameText>{name}</StyledTopicNameText>
                    <StyledTopicDomainCount isExtraItem={isExtraTopicItem}>
                        ({formatNumberWithComa(domainsCount)})
                    </StyledTopicDomainCount>
                </StyledTopicName>
            </StyledTopicBlock>
            {isLocked && !isNotApplied ? (
                <PlainTooltip
                    text={translate("si.intent.management.tooltip.lockedRemove")}
                    placement="top"
                    maxWidth={130}
                >
                    <StyledTopicRemoveBtnWrapper>
                        <IconButton
                            iconSize="xs"
                            type="flat"
                            iconName="locked"
                            isDisabled={true}
                        />
                    </StyledTopicRemoveBtnWrapper>
                </PlainTooltip>
            ) : (
                <StyledTopicRemoveBtnCrossWrapper>
                    <IconButton
                        iconSize="xs"
                        type="flat"
                        iconName="close"
                        onClick={() => onRemoveTopic(topic)}
                    />
                </StyledTopicRemoveBtnCrossWrapper>
            )}
        </StyledIntentSelectedTopicItemContainer>
    );
};

export default IntentSelectedTopicItem;
